<div class="arrangementPanel" data-ctx="pallet-arrangement-panel">
  @if (editMode) {
    @if (layersLoading) {
      <p class="emptyHint" data-ctx="pallet-arrangement-loading">...</p>
    } @else if (!editRows.length) {
      <p class="emptyHint" data-ctx="pallet-arrangement-empty">{{ 'layer_arrangement_empty' | translate }}</p>
    } @else {
      <table class="layersTable" [formGroup]="editForm" data-ctx="pallet-arrangement-edit-table">
        <thead>
          <tr>
            <th>
            <span class="specHeader">
              {{ 'pallet_layers_specification' | translate }}
              <div class="info" [glTooltip]="'pallet_layers_specification_info'" [width]="'320px'">i</div>
            </span>
          </th>
            <th class="countCol">{{ 'pallet_layer_stack_count' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @for (row of editRows; track $index; let i = $index) {
            <tr
              [class.rowDisabled]="!row.saveable"
              data-ctx="pallet-arrangement-edit-row"
              >
              <td>
                @let label = getEditRowLabelView(row);
                <span class="optionLabel">
                  <span class="optionLabelLine optionLabelLineSummary">
                    <span class="optionLabelName">{{ label.name }}</span>
                    <span class="optionLabelDimensions">{{ label.dimensionsText }}</span>
                  </span>
                  <span class="optionLabelLine"
                    ><span class="optionLabelQuantityLabel">{{ label.loadCountLabel }}: </span
                    >{{ label.quantity }}</span
                  >
                </span>
              </td>
              <td class="countCol">
                <gl-input-container class="countInput">
                  <input
                    type="text"
                    [numericType]="'integer'"
                    normal-input
                    [formControlName]="'row_' + i"
                    [attr.data-ctx]="'input-layer-count-' + i"
                    />
                </gl-input-container>
              </td>
            </tr>
          }
        </tbody>
      </table>
    }
  } @else if (!layers.length) {
    <p class="emptyHint" data-ctx="pallet-arrangement-empty">{{ 'layer_arrangement_empty' | translate }}</p>
  } @else {
    <table
      class="layersTable"
      [formGroup]="form"
      #layersToAddForm="ngForm"
      data-ctx="pallet-arrangement-add-table"
      >
      <thead>
        <tr>
          <th>
            <span class="specHeader">
              {{ 'pallet_layers_specification' | translate }}
              <div class="info" [glTooltip]="'pallet_layers_specification_info'" [width]="'320px'">i</div>
            </span>
          </th>
          <th class="countCol">{{ 'pallet_layer_stack_count' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        @for (layer of layers; track layer.id) {
          <tr
            [class.selected]="selectedLayerId === layer.id"
            (click)="selectLayer(layer)"
            data-ctx="pallet-arrangement-option"
            >
            <td>
              <label class="optionSelect">
                <input
                  type="radio"
                  name="palletLayerArrangement"
                  [value]="layer.id"
                  [checked]="selectedLayerId === layer.id"
                  (change)="selectLayer(layer)"
                  (click)="$event.stopPropagation()"
                  />
                @let label = getLayerLabelView(layer);
                <span class="optionLabel">
                  <span class="optionLabelLine optionLabelLineSummary">
                    <span class="optionLabelName">{{ label.name }}</span>
                    <span class="optionLabelDimensions">{{ label.dimensionsText }}</span>
                  </span>
                  <span class="optionLabelLine"
                    ><span class="optionLabelQuantityLabel">{{ label.loadCountLabel }}: </span
                    >{{ label.quantity }}</span
                  >
                </span>
              </label>
            </td>
            <td class="countCol" (click)="$event.stopPropagation()">
              <gl-input-container class="countInput">
                <input
                  type="text"
                  [numericType]="'integer'"
                  normal-input
                  [formControlName]="'count_' + layer.id"
                  [attr.data-ctx]="'input-layer-count-add-' + layer.id"
                  (change)="onLayerCountsInput()"
                  (blur)="onLayerCountsInput()"
                  />
              </gl-input-container>
            </td>
          </tr>
        }
      </tbody>
    </table>
  }
</div>
